import { fromJS } from 'immutable';

import { saveSortingPropertiesType, similarityMolKey } from './SortingPropertiesConstants';

export const initialState = fromJS({
  similarityMoll: null,
});

// eslint-disable-next-line default-param-last
export default function sortingPropertiesReducer(state = initialState, action) {
  if (action.type === saveSortingPropertiesType) {
    const { key, data, similarityMol } = action.payload;
    return state.set(key, fromJS(data)).set(similarityMolKey, fromJS(similarityMol));
  }
  return state;
}
